export default "__VITE_ASSET__DOOfwkGC__"